import { Moment } from 'moment';
import { DatePickerProps } from '../iPicker';

const getPresetList = (now: Moment) => [
    {
        label: '今天',
        key: 'today',
        value: now.clone().startOf('day'),
    },
    {
        label: '昨天',
        key: 'yesterday',
        value: now.clone().startOf('day').add(-1, 'd'),
    },
    {
        label: '明天',
        key: 'tomorrow',
        value: now.clone().startOf('day').add(1, 'd'),
    },
    {
        label: '一周后',
        key: 'oneWeekLater',
        value: now.clone().add(1, 'w').startOf('day'),
    },
    {
        label: '一月后',
        key: 'oneMonthLater',
        value: now.clone().startOf('day').add(1, 'M'),
    },
    {
        label: '半年后',
        key: 'halfYearLater',
        value: now.clone().startOf('day').add(6, 'M'),
    },
    {
        label: '一年后',
        key: 'oneYearLater',
        value: now.clone().startOf('day').add(1, 'y'),
    },
]

export const getPresets = (presets: DatePickerProps['presets'], now: Moment) => {
    const presetList = getPresetList(now)
    const presetKeys = presetList.map(item => item.key)
    if (presets === true) {
        return presetList
    } else if (Array.isArray(presets)) {
        return presets.map(item => {
            if (typeof item === 'string' && presetKeys.includes(item)) {
                return presetList.find(presetItem => presetItem.key === item)
            } else if (typeof item === 'object' && item.key && item.label && item.value) {
                return item
            }
        })
    }
}

export const getActivePresetLabel = ({presets, activePresetKey}: any) => {
    let activePresetLabel = ''
    if (Array.isArray(presets)) {
        presets.map(range => {
            if (range.key === activePresetKey || range.label === activePresetKey) {
                activePresetLabel = range.label
            }
        })
    }
    return activePresetLabel
}
